export default "__VITE_ASSET__557c5478__"